import { z } from 'zod'
import { CurrencyCodesSchema } from '@reward-platform/platform-config'
import {
  PaginationSchema,
  RoomSchema,
  PopularAmenityIconSchema,
  WarningSchema,
  PromotionConfigSchema,
  FlexiDetailsRoomSchema,
  ResponseShoppingFilterSchema,
} from '../../common'

const LatLongLocation = z.object({
  latitude: z.number().optional(),
  longitude: z.number().optional(),
})

const HotelSearchResultSchema = z.object({
  bundleId: z.string(),
  vendorName: z.string(),
  propertyLocation: LatLongLocation,
  rooms: z.array(RoomSchema),
  vendorId: z.string(),
  imageUrl: z.string().optional(),
  starRating: z.number(),
  guestRating: z.number(),
  guestRatingCount: z.number(),
  currencyCode: CurrencyCodesSchema,
  surcharges: z.number().optional(),
  popularAmenities: z.array(PopularAmenityIconSchema),
  category: z.string().optional(),
  brand: z.string().optional(),
  registryNumber: z.string().optional(),
  promotionConfig: PromotionConfigSchema.optional(),
})

export const FlexiHotelSearchResultSchema = HotelSearchResultSchema.omit({
  currencyCode: true,
}).extend({
  rooms: z.array(FlexiDetailsRoomSchema),
})

export const HotelSearchDataTransferObjectSchema = z.object({
  correlationId: z.string(),
  recommendationId: z.string(),
  results: z.array(HotelSearchResultSchema),
  pagination: PaginationSchema,
  warnings: z.array(WarningSchema).optional(),
  shoppingFilter: ResponseShoppingFilterSchema.optional(),
})

export const FlexiHotelSearchDataTransferObjectSchema = HotelSearchDataTransferObjectSchema.extend({
  results: z.array(FlexiHotelSearchResultSchema),
})

export type HotelSearchResult = z.infer<typeof HotelSearchResultSchema>
export type HotelSearchDataTransferObject = z.infer<typeof HotelSearchDataTransferObjectSchema>
export type FlexiHotelSearchResult = z.infer<typeof FlexiHotelSearchResultSchema>
